// extracted by mini-css-extract-plugin
export default {"infoCircle":"BudgetFileModelScreen_infoCircle__WczFh"};